import cx from 'classnames';
import { ChevronDown } from 'ethena-icons';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { useOnClickOutside } from '../../../lib/hooks/useOnClickOutside';
import { useToggle } from '../../../lib/hooks/useToggle';
import css from './Dropdown.module.scss';

const DropdownToggle = React.forwardRef(
  ({ children = null, className = '', ...props }, ref) => (
    <div className={cx(css.toggle, className)} {...props} ref={ref}>
      {children}
      <ChevronDown />
    </div>
  )
);

DropdownToggle.displayName = 'DropdownToggle';

DropdownToggle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

const DropdownMenu = React.forwardRef(
  ({ children = null, className = '', ...props }, ref) => {
    return (
      <div className={cx(css.menu, className)} {...props} ref={ref}>
        {children}
      </div>
    );
  }
);

DropdownMenu.displayName = 'DropdownMenu';

DropdownMenu.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

const Dropdown = ({
  children = null,
  className = '',
  closeOnMenuClick = false,
  menuClassName = '',
  title = 'Dropdown button',
  toggleClassName = '',
  ...props
}) => {
  const menuRef = useRef();
  const toggleRef = useRef();
  const [isOpen, toggleIsOpen] = useToggle(false);
  useOnClickOutside(menuRef, (e) => {
    if (toggleRef.current !== e.target) {
      if (isOpen) {
        toggleIsOpen();
      }
    }
  });

  const handleMenuClick = () => {
    if (closeOnMenuClick) {
      toggleIsOpen();
    }
  };

  return (
    <div className={cx(css.dropdown, { [css.open]: isOpen }, className)}>
      <DropdownToggle
        className={toggleClassName}
        {...props}
        onClick={toggleIsOpen}
        ref={toggleRef}
      >
        <span className={css.title}>{title}</span>
      </DropdownToggle>
      <DropdownMenu
        className={menuClassName}
        onClick={handleMenuClick}
        ref={menuRef}
      >
        {children}
      </DropdownMenu>
    </div>
  );
};

Dropdown.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  closeOnMenuClick: PropTypes.bool,
  menuClassName: PropTypes.string,
  title: PropTypes.string,
  toggleClassName: PropTypes.string,
};

Dropdown.Menu = DropdownMenu;
Dropdown.Toggle = DropdownToggle;

export { Dropdown };
